// Funnel answer ids → numeric ids of the production lists in web-onboarding's public/data.json
// (`languages`, `hows`, `whys`, `struggles`, `topics`). The app and the backend know options by these numbers.
// Matched by title against the production data.json of 2 Nov 2026 — check again if the production lists change.

export const LANGUAGE_IDS: Record<string, number> = {
  bg: 67, zh: 96, cs: 68, de: 69, en: 97, uk: 94, es: 71, fi: 72, fr: 73, el: 70,
  id: 76, it: 77, ja: 79, ko: 82, pl: 86, pt: 87, ru: 89, sv: 90, tr: 93,
}; // "other" has no production id

export const STUDY_HISTORY_IDS: Record<string, number> = { school: 1, university: 2, abroad: 3, tutor: 4, apps: 5, textbooks: 6 }; // hows

export const GOAL_IDS: Record<string, number> = { vacation: 1, business: 2, liveAbroad: 3, friends: 4, fun: 5, exam: 6 }; // whys ("business" = "Work")

export const STRUGGLE_IDS: Record<string, number> = { fear: 1, practice: 3, listening: 4, pronunciation: 5, vocabulary: 6 };

export const TOPIC_IDS: Record<string, number> = {
  adventure: 1, art: 2, style: 3, business: 4, career: 5, doctor: 8, embassy: 10, food: 11, gym: 12,
  party: 13, politics: 14, restaurant: 15, romance: 16, shopping: 17, tech: 18, travel: 19,
}; // production 7 "Daily Life" is not offered in the new funnel

const one = (map: Record<string, number>, v: unknown) => (typeof v === "string" && map[v] !== undefined ? map[v] : null);
const many = (map: Record<string, number>, v: unknown) =>
  Array.isArray(v) ? v.map((x) => one(map, x)).filter((x): x is number => x !== null) : [];

export type ProductionIds = {
  languageId: number | null;
  howIds: number[];
  whyId: number | null;
  struggleIds: number[];
  topicIds: number[];
};

/** The funnel's answers expressed in production ids — sent next to `answers` in POST /api/plan. */
export function toProductionIds(answers: Record<string, unknown>): ProductionIds {
  return {
    languageId: one(LANGUAGE_IDS, answers.language),
    howIds: many(STUDY_HISTORY_IDS, answers.studyHistory), // multi-select
    whyId: one(GOAL_IDS, answers.goal),
    struggleIds: many(STRUGGLE_IDS, answers.struggles),
    topicIds: many(TOPIC_IDS, answers.topics),
  };
}
